import React, { useState } from 'react'
import { useId } from 'react'

import { Box, Tooltip } from '@factorialco/deprecated-design-system'
import classNames from 'classnames'
import { LayoutGroup } from 'framer-motion'
import _ from 'lodash'

import LabeledInput from 'modules/core/components/LabeledInput'

import './index.styles.css'
interface Props {
  min: number
  max: number
  value?: number | null | undefined
  onClick?: (value: number) => void
  readonly?: boolean
  mandatory?: boolean
  hasTooltip?: boolean
  tooltipLabel?: string
  onHover?: (hoveredRating: number) => void
}
export default function PerformanceRatingInput(props: Props) {
  const {
    min,
    max,
    value,
    onClick,
    readonly,
    mandatory,
    hasTooltip = false,
    tooltipLabel,
    onHover,
  } = props

  const [hoveredRating, setHoveredRating] = useState<number | null>(null)

  const onClickButton = (event: React.SyntheticEvent<HTMLElement>, r: number) => {
    event.preventDefault()
    onClick && onClick(r)
  }
  const layoutGroupId = useId()
  const handleMouseEnter = (r: number) => {
    setHoveredRating(r)
    onHover && onHover(r)
  }
  const handleMouseLeave = () => {
    setHoveredRating(null)
  }

  return (
    <LabeledInput mandatory={mandatory} isLegend>
      <Box flexDirection="row">
        <LayoutGroup id={layoutGroupId}>
          {_.range(min, max + 1).map((r) => {
            const checked = r === value
            const isHovered = r === hoveredRating
            return (
              <button
                className={classNames('RatingInput_item', {
                  ['RatingInput_checkedItem']: checked,
                  ['RatingInput_readonlyItem']: readonly,
                })}
                disabled={readonly}
                key={r}
                onClick={(event) => onClickButton(event, r)}
                onMouseEnter={() => {
                  handleMouseEnter(r)
                }}
                onMouseLeave={handleMouseLeave}
                aria-pressed={checked}
              >
                <Tooltip.Alt
                  key={r}
                  attachment="top center"
                  label={tooltipLabel}
                  open={isHovered && hasTooltip}
                >
                  <div>
                    {checked && (
                      <Box.Motion
                        layout
                        layoutId={layoutGroupId}
                        className={classNames('RatingInput_checkBackground', {
                          ['RatingInput_readonlyCheck']: readonly,
                        })}
                      ></Box.Motion>
                    )}
                    <Box position="relative">{r}</Box>
                  </div>
                </Tooltip.Alt>
              </button>
            )
          })}
        </LayoutGroup>
      </Box>
    </LabeledInput>
  )
}
